const USER_STATISTIC = '/user-statistic';

export function userStatistic() {
  return USER_STATISTIC;
}

export function ipdUserImpressions() {
  return `${USER_STATISTIC}/ipd-impressions`;
}
